<template>
    <div class="main">
        <div class="box">
            <div class="left" v-if="isMenuShow">
                <div class="logo" :style="`background-image:url(${firmLogo})`"></div>
                <div class="menu_title">{{ curMenuTitle }}</div>
                <el-menu
                    class="menu"
                    router
                    unique-opened
                    active-text-color="#ffffff"
                    text-color="rgba(255,255,255, 0.7)"
                    background-color="rgba(25, 158, 216, 1)"
                >
                    <!-- 一级有children -->
                    <template v-for="(e, i) in curMenuList">
                        <el-submenu v-if="e.children && e.children.length > 0" :index="i.toString()" :key="i">
                            <template slot="title">
                                <span class="mtitle icon_special">{{ e.title }}</span>
                            </template>
                            <template v-for="(ev, j) in e.children">
                                <!-- 二级有children  -->
                                <el-submenu
                                    v-if="ev.children && ev.children.length > 0"
                                    class="second_submenu"
                                    :index="i + '-' + j"
                                    :key="i + '' + j"
                                >
                                    <template slot="title">
                                        <span class="mtitle icon_pagechild">{{ ev.title }}</span>
                                    </template>
                                    <!-- 三级 -->
                                    <template v-for="(et, it) in ev.children">
                                        <el-menu-item
                                            class="third_menu_item"
                                            :key="i + '-' + j + '-' + it"
                                            :index="et.link ? et.link : `${i}-${j}-${it}`"
                                        >
                                            <span class="mitem">{{ et.title }}</span>
                                        </el-menu-item>
                                    </template>
                                </el-submenu>

                                <!-- 二级没children  -->
                                <el-menu-item
                                    v-else
                                    class="sub_menu_item"
                                    :key="i + '-' + j"
                                    :index="ev.link ? ev.link : `${i}-${j}`"
                                >
                                    <span class="mitem">{{ ev.title }}</span>
                                </el-menu-item>
                            </template>
                        </el-submenu>
                        <!-- 一级没children -->
                        <el-menu-item v-else :key="i" :index="e.link ? e.link : `${i}`">
                            <span :class="['mtitle', e.iconClass || 'icon_special']">{{ e.title }}</span>
                        </el-menu-item>
                    </template>
                </el-menu>
            </div>
            <div class="right">
                <div class="headmain">
                    <div class="headmainmiddle">{{ firmTitle }}</div>
                    <div class="headmainleft switch_menu" @click="ShowMenu"></div>
                    <div :class="['headmainicon', `icon_${i}`]" v-for="(e, i) in menu" :key="i" @click="setCurMenu(e)">
                        {{ e.title }}
                    </div>
                    <div class="help_btn">
                        <a href="/static/help.pdf" target="blank">
                            <i class="el-icon-question"></i>
                        </a>
                        <div class="btn_text">帮助文档</div>
                    </div>
                    <el-dropdown class="username headmainright" @command="handleClick" :style="usernameWidth">
                        <span class="el-dropdown-link" style="color: #fff">
                            <span v-if="session">{{ session.userInfo.username }}</span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="edit">修改密码</el-dropdown-item>
                            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                <router-view class="routerView" @changeMenu="getPageMenu" />
                <el-dialog title="修改密码" :visible.sync="dialogClientVisible" width="30%">
                    <el-form :rules="clientFormRules" :model="clientForm" ref="clientForm">
                        <el-form-item prop="oldPassword">
                            <el-input
                                type="password"
                                v-model="clientForm.oldPassword"
                                placeholder="请输入原密码"
                            ></el-input>
                        </el-form-item>

                        <el-form-item prop="password">
                            <el-input
                                type="password"
                                v-model="clientForm.password"
                                placeholder="请输入新密码"
                            ></el-input>
                        </el-form-item>

                        <el-form-item prop="surePassword">
                            <el-input
                                type="password"
                                v-model="clientForm.surePassword"
                                placeholder="请输入新密码"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button
                            @click="
                                dialogClientVisible = false
                                $refs.clientForm.resetFields()
                            "
                            >取 消</el-button
                        >
                        <el-button type="primary" @click="submitClientForm">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import menu from '../menu'
export default {
    data() {
        let surePassword = (rule, value, callback) => {
            if (value === this.clientForm.password) {
                callback();
            } else {
                callback(new Error("两次输入密码不一致"));
            }
        };
        return {
            menu: [],
            curMenuTitle: '',
            curMenuList: [],
            isMenuShow: true,
            session: null,
            active: "",
            dialogClientVisible: false,
            clientForm: {
                oldPassword: "",
                password: "",
                surePassword: ""
            },
            clientFormRules: {
                oldPassword: [
                    {
                        required: true,
                        message: "请填写旧密码",
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        required: true,
                        message: "请填写新密码",
                        trigger: "blur"
                    }
                ],
                surePassword: [
                    {
                        required: true,
                        message: "请确认密码",
                        trigger: "blur"
                    },
                    {
                        validator: surePassword
                    }
                ]
            },
            noPermiss: [] //无权限list
        };
    },
    watch: {
        '$route.path'(val) {
            if (val === '/websiteManager' && this.noPermiss.length > 0) {
                this.$message.error('您无权限访问此页面,请联系管理员')
                this.$router.push('/')
            }
        }
    },
    computed: {
        firmTitle() {
            return this.$store.state.websiteInfo.firmName|| ''
        },
        firmLogo() {
            return this.$store.state.websiteInfo.firmLogoUrl || ''
        },
        websiteId() {
            let firmInfo = JSON.parse(sessionStorage.getItem('session'))
                .firmInfo
            if (firmInfo) {
                return firmInfo.id
            }
            return ''
        },
    },
    mounted() {
        let permissList = JSON.parse(sessionStorage.getItem("permiss")) || [];
        this.session = JSON.parse(sessionStorage.getItem("session"));
        // 写死admin账号-公司管理页面权限(仅显示)
        if (this.session && this.session.userInfo.id !== 1) {
            this.noPermiss.push('page-websiteManager')
            if (this.$route.path === '/websiteManager') {
                this.$message.error('您无权限访问此页面,请联系管理员')
                this.$router.push('/')
            }
        }
        menu.menuTree.forEach((e, i) => {
            if (this.noPermiss.findIndex(p => p === e.permiss) === -1) {
                this.menu.push({ //子侧边栏无权限,父不显示
                    title: e.title,
                    children: e.children || [],
                    link: e.link || '',
                })
            }
        })
        console.log(this.menu)
        this.menu.forEach(e => {
            e.children.forEach(ev => {
                this.active = this.$route.path
            })
        });
        this.getPageMenu()
    },
    methods: {
        getPageMenu() {
            let id = this.websiteId
            this.ajax.post(`/module/admin/getModuleParentList?websiteId=${id}`).then(res => {
                this.menu[0].children = this.recursion(res)
                this.curMenuTitle = this.menu[0].title
                this.curMenuList = this.menu[0].children
            })
        },
        // 递归处理cascader
        recursion(data) {
            if (Array.isArray(data)) {
                let newdata = data.reduce((acc, cur) => {
                    if (cur.id === 35) {
                        console.log(cur);
                    }
                    cur.title = cur.moduleName
                    cur.link = cur.isMany
                        ? `/module/moduleDetailManyManager?id=${cur.id}`
                        : `/module/moduleDetailSingleManager?moduleId=${cur.id}`
                    if (!cur.children) {
                        acc.push(cur)
                    } else if (cur.children.length === 0) {
                        let newObj = Object.assign({}, cur)
                        delete newObj.children
                        acc.push(newObj)
                    } else {
                        let newObj = Object.assign({}, cur)
                        newObj.children = this.recursion(cur.children)
                        acc.push(newObj)
                    }
                    return acc
                }, [])
                return newdata
            } else return ''
        },
        isActive(i) {
            if (this.menu[i].children.length > 0) {
                return this.menu[a].children.filter(
                    e => location.href.indexOf(e.link) > -1
                ).length;
            } else return location.href.indexOf(this.menu[i].link) !== -1
        },
        handleClick(item) {
            switch (item) {
                case "logout":
                    this.logout();
                    break;
                case "edit":
                    this.resetPassword();
                    break;
            }
        },
        //退出登录
        logout: function () {
            var _this = this;
            this.$confirm("确认退出吗?", "提示", {})
                .then(() => {
                    this.ajax.post("/logout").then(data => {
                        sessionStorage.removeItem("session");
                        sessionStorage.removeItem("permiss");
                        this.$router.replace("/");
                    });
                })
                .catch(() => { });
        },
        resetPassword() {
            this.dialogClientVisible = true;
        },
        submitClientForm() {
            this.ajax.post("/user/updateUserPassword", this.clientForm).then(data => {
                this.$message({
                    type: "success",
                    message: "操作成功！"
                });
                this.$refs.clientForm.resetFields();
                this.dialogClientVisible = false;
            });
        },
        usernameWidth() {
            if (this.session.userInfo) {
                return `width:${(session.userInfo.username.length || 0) + 2}em;`
            } else return "width:100px;"

        },
        ShowMenu() {
            if (this.isMenuShow == false) {
                this.isMenuShow = true;
            } else {
                this.isMenuShow = false;
            }
        },
        setCurMenu(menu) {
            this.curMenuTitle = menu.title
            this.curMenuList = menu.children || []
            if (this.curMenuList.length <= 0) {
                this.$router.push(menu.link)
            }
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    display: flex;
}
.left {
    width: 232px;
    min-height: 100vh;
    background-color: rgba(25, 158, 216, 1);
    color: #fff;
}
.logo {
    margin: 10px 0;
    height: 100px;
    padding-top: 100px;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url(../assets/main/logo.png);
    background-size: contain;
    font-size: 14px;
    text-align: center;
    color: rgba(255, 255, 255, 0.9);
}
.el-menu {
    border-right: solid 1px #fff;
}
.menu {
    height: auto;
    ::v-deep .el-submenu__title i {
        color: #fff !important;
    }
}
// /deep/.second_submenu > .el-submenu__title .mtitle::before,
// .sub_menu_item .mtitle::before {
// background-color: #0070a0 !important;
// border-bottom: 0.5px solid #055577;
// }
// .third_menu_item {
//     background-color: rgb(5, 85, 119) !important;
//     border-bottom: 0.5px solid #3b3838;
// }

// .el-menu-item > span {
//     &:hover {
//         color: #3cb7fd;
//     }
//     &.is-active {
//         color: rgb(5, 85, 119) !important;
//     }
// }
::v-deep .el-submenu__title:hover,
.el-menu-item:hover,
.el-menu-item.is-active {
    background-color: rgba(113, 193, 228, 1) !important;
    color: #fff !important;
    .mitem::before {
        background-color: rgba($color: #fff, $alpha: 1);
    }
}

.mtitle {
    font-size: 16px;
    user-select: none;
}
.mtitle::before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: cover;
    margin: 0 8px 0 0;
}

.icon_0 {
    background-image: url('../assets/main/ipage.png');
}
.icon_1 {
    background-image: url('../assets/main/icompany.png');
}
.icon_2 {
    background-image: url('../assets/main/imodule.png');
}
.icon_3 {
    background-image: url('../assets/main/istatics.png');
}
.icon_4 {
    background-image: url('../assets/main/iall.png');
}

.icon_mymessage::before {
    background-image: url(../assets/main/account.png);
}
.icon_company::before {
    background-image: url(../assets/main/business.png);
}
.icon_classify::before {
    background-image: url(../assets/main/classify.png);
}
.icon_bottomnav::before {
    background-image: url(../assets/main/bottom_nav.png);
}
.icon_banner::before {
    background-image: url(../assets/main/banner.png);
}
.icon_page::before {
    background-image: url(../assets/main/order.png);
}
.icon_suggestion::before {
    background-image: url(../assets/main/suggestion.png);
}
.icon_stcechart::before {
    background-image: url(../assets/main/stc_echart.png);
}
.icon_stcmanager::before {
    background-image: url(../assets/main/stc_manager.png);
}
.icon_pagechild::before {
    background-image: url(../assets/main/page_child.png);
}
.icon_special::before {
    background-image: url(../assets/main/order.png);
}

.mitem {
    font-size: 14px;
    &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        background-color: rgba($color: #fff, $alpha: 0.7);
        margin-right: 8px;
        border-radius: 50%;
        vertical-align: 2px;
    }
}
.right {
    background-color: #ffffff;
    width: calc(100%);
    min-width: 80vw;
}
.headLeft {
    line-height: 50px;
    padding-left: 10px;
    width: calc(100% - 145px);
    color: rgba(255, 255, 255, 0.986);
}
.head {
    height: 50px;
    padding-right: 30px;
    background-color: #353535;
    border-left: 2px solid #6b6969;
}
.head div {
    float: right;
    font-size: 14px;
    line-height: 50px;
    color: rgba(255, 255, 255, 0.9);
    cursor: pointer;
}
.head div::before {
    content: '';
    position: relative;
    top: 4px;
    margin-right: 10px;
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: cover;
}
.logOut::before {
    background-image: url(../assets/main/logOut.png);
    margin-left: 60px;
}
.account::before {
    background-image: url(../assets/main/account.png);
}

.menu_title {
    background-color: #fff;
    background: rgba(25, 158, 216, 1);
    height: 50px;
    font-size: 20px;
    font-weight: bold;
    padding-left: 20px;
    line-height: 50px;
}
.headmain {
    position: relative;
    height: 60px;
    padding: 0px 10px;
    background-color: rgba(25, 158, 216, 1);
    border-left: 2px solid #fff;
}
.headmainleft {
    width: 50px;
    height: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: rgb(252, 253, 253);
    background-size: 25px 25px;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
}
.switch_menu {
    background-image: url(../assets/index.png);
}
.headmainicon {
    height: 100%;
    float: left;
    color: rgb(252, 253, 253);
    background-size: 25px 25px;
    background-repeat: no-repeat;
    background-position: center 8px;
    cursor: pointer;
    font-size: 12px;
    padding-top: 35px;
    margin: 0 10px;
}

.headmainmiddle {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 20px;
    font-weight: bold;
    color: rgb(252, 253, 253);
    transform: translate(-50%, -50%);
}
.headmainright {
    height: 100%;
    float: right;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: rgb(252, 253, 253);
}
.help_btn {
    float: right;
    margin-left: 10px;
    width: 50px;
    height: 100%;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    i {
        color: #fff;
        font-size: 24px;
    }
    .btn_text {
        display: none;
    }
}
.help_btn:hover {
    .btn_text {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/main.vue